const SELECTED_VENUE_KEY = 'sc_sv';
const LAST_SELECTED_VENUE_KEY = 'sc_lsv';

const getSelectedVenue = () => {
  try {
    const session = sessionStorage.getItem(SELECTED_VENUE_KEY);

    if (session) {
      return JSON.parse(sessionStorage.getItem(SELECTED_VENUE_KEY));
    }

    return JSON.parse(localStorage.getItem(LAST_SELECTED_VENUE_KEY));
  } catch (e) {
    try {
      return JSON.parse(localStorage.getItem(LAST_SELECTED_VENUE_KEY));
    } catch (f) {
      return null;
    }
  }
};

const updateSelectedVenue = venue => {
  sessionStorage.setItem(SELECTED_VENUE_KEY, venue ? JSON.stringify(venue) : null);
  localStorage.setItem(LAST_SELECTED_VENUE_KEY, venue ? JSON.stringify(venue) : null);
};

export { getSelectedVenue, updateSelectedVenue };



// WEBPACK FOOTER //
// ./src/lib/venueSelector.js